import { IBulkActionRequest } from "@shared/lib/types/brief";

export function buildCampaignBulkFilterParams(
  payload: Record<string, unknown>
): IBulkActionRequest["filterParams"] {
  const { limit: _limit, status: _status, ...rest } = payload;
  return rest as IBulkActionRequest["filterParams"];
}

export function getExecutionSelectedCount(
  selectAll: boolean,
  checkedCount: number,
  uncheckCount: number,
  totalCount?: number
) {
  if (selectAll) {
    return Math.max(0, (totalCount || 0) - uncheckCount);
  }
  return checkedCount;
}
